import { render, staticRenderFns } from "./ProcessSpecialities.vue?vue&type=template&id=77a446d2&scoped=true"
import script from "./ProcessSpecialities.vue?vue&type=script&lang=js"
export * from "./ProcessSpecialities.vue?vue&type=script&lang=js"
import style0 from "./ProcessSpecialities.vue?vue&type=style&index=0&id=77a446d2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a446d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardSubtitle,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon})
